module.exports = __webpack_public_path__ + "img/1513691514.2879e205.jpg";